import { lazy, Suspense } from "react";
import { ADMIN_ROUTES, USER_ROUTES } from "../constants/appRoutes";
import { Navigate, Route, Routes } from "react-router-dom";
import Loader from "../components/Loader";
import CategoryPageLayout from "../pages/admin/Categories/Category";
const BookCallListPage = lazy(() => import("../pages/admin/BookCall"));
const SubCategoryPage = lazy(
  () => import("../pages/admin/Categories/Category/SubCategory/SubCategoryList")
);
const WhatsAppList = lazy(() => import("../pages/admin/WhatsApp/WhatsAppList"));
const WhatsAppSendMessage = lazy(() => import("../pages/admin/WhatsApp/Send"));
const AmenitiesPage = lazy(
  () => import("../pages/admin/Categories/Amenities/AmenitiesList")
);

const AreaListPage = lazy(
  () => import("../pages/admin/Categories/Area/AreaList")
);
const ViewSalesDataPage = lazy(
  () => import("../pages/admin/SalesData/ViewSalesData")
);

const AdvertisePage = lazy(() => import("../pages/admin/Advertise"));
const SalesRecordsPage = lazy(() => import("../pages/admin/SalesData"));
const CmsAboutPage = lazy(() => import("../pages/admin/CMS/AboutUs"));
const CategoryMenuLayout = lazy(() => import("../pages/admin/Categories"));
const AllStaffFormActionPage = lazy(
  () => import("../pages/admin/ManageStaff/AllStaff/AllStaffFormAction")
);
const CmsPageLayout = lazy(() => import("../pages/admin/CMS"));
const ManageStaffLayout = lazy(() => import("../pages/admin/ManageStaff"));
const RealEstateLayout = lazy(() => import("../pages/admin/RealEstate"));
const ReportLayout = lazy(() => import("../pages/admin/Reports"));
const FaqsCategoryPage = lazy(
  () => import("../pages/admin/Categories/FaqsCategory/FaqsCategoryList")
);
const ReportsList = lazy(() => import("../pages/admin/Reports/ReportsList"));
const SingleReport = lazy(() => import("../pages/admin/Reports/SingleReport"));

const SliderFormAction = lazy(
  () => import("../pages/admin/CMS/SliderImage/SliderFormAction")
);
const NotificationList = lazy(
  () => import("../pages/admin/Notification/NotificationList")
);
const SliderImageList = lazy(
  () => import("../pages/admin/CMS/SliderImage/SliderImageList")
);
const ReelsList = lazy(() => import("../pages/admin/Reels/Reels"));
const CustomerListPage = lazy(
  () => import("../pages/admin/Customer/CustomerList")
);
const Dashboard = lazy(() => import("../pages/admin/Dashboard"));
const AllStaffPage = lazy(
  () => import("../pages/admin/ManageStaff/AllStaff/AllStaff")
);
const ViewEnquiryForm = lazy(
  () => import("../pages/admin/Enquiry/ViewEnquiryForm")
);
const EnquiryListPage = lazy(
  () => import("../pages/admin/Enquiry/EnquiryList")
);
const FactFeaturesPage = lazy(
  () => import("../pages/admin/Categories/FactFeatures/FactFeatures")
);
const TermAndService = lazy(() => import("../pages/admin/CMS/TermsAndService"));
const CategoryPage = lazy(
  () => import("../pages/admin/Categories/Category/Category/CategoryList")
);
const ImageCategoryPage = lazy(
  () => import("../pages/admin/Categories/ImageCategory/ImageCategory")
);
const Groups = lazy(() => import("../pages/admin/Categories/Group/Groups"));
const FaqsPage = lazy(() => import("../pages/admin/CMS/FAQs/Faqs"));
const FaqsFormPage = lazy(() => import("../pages/admin/CMS/FAQs/FaqsForm"));
const Agent = lazy(() => import("../pages/admin/Agent/AgentList"));
const NewAgent = lazy(() => import("../pages/admin/Agent/NewAgent"));
const AgentDetail = lazy(() => import("../pages/admin/Agent/AgentDetail"));
const Properties = lazy(
  () => import("../pages/admin/RealEstate/Properties/Properties")
);
const NewProperty = lazy(
  () => import("../pages/admin/RealEstate/Properties/NewProperty")
);
const ViewProperty = lazy(
  () => import("../pages/admin/RealEstate/Properties/ViewProperty")
);
const ViewProject = lazy(
  () => import("../pages/admin/RealEstate/Projects/ViewProject")
);
const Projects = lazy(
  () => import("../pages/admin/RealEstate/Projects/Projects")
);
const NewProject = lazy(
  () => import("../pages/admin/RealEstate/Projects/NewProject")
);
const FeedbackListPage = lazy(
  () => import("../pages/admin/Feedback/FeedbackList")
);
const BlogPost = lazy(() => import("../pages/admin/Blog/BlogPost"));
const NewBlog = lazy(() => import("../pages/admin/Blog/NewBlog"));
const BuilderListPage = lazy(
  () => import("../pages/admin/Builder/BuilderList")
);
const BuilderFormPage = lazy(
  () => import("../pages/admin/Builder/BuilderActionsForm")
);
const BuilderDetail = lazy(
  () => import("../pages/admin/Builder/BuilderDetail")
);
const Roles = lazy(() => import("../pages/admin/ManageStaff/Roles/Roles"));
const NewRoles = lazy(
  () => import("../pages/admin/ManageStaff/Roles/NewRoles")
);
const Contact = lazy(() => import("../pages/admin/Contact/Contact"));
const Profile = lazy(() => import("../pages/admin/Profile/Profile"));
const SalesTeam = lazy(() => import("../pages/builder/SalesTeam/SalesTeam"));
const SalesLocationHistoryPage = lazy(
  () => import("../pages/builder/SalesTeam/LocationHistory")
);
const NewSalesMember = lazy(
  () => import("../pages/builder/SalesTeam/NewSalesMember")
);
const Leads = lazy(() => import("../pages/admin/Leads/Leads"));
const EditLeadPage = lazy(() => import("../pages/admin/Leads/EditLead"));
const SEO = lazy(() => import("../pages/admin/SEO/Seo"));

const AdminRoutes = () => {
  return (
    <Suspense
      fallback={
        <div className="flex justify-center items-center h-[100vh]">
          <Loader />
        </div>
      }
    >
      <Routes>
        <Route path={USER_ROUTES.ROOT} element={<Dashboard />} />
        <Route path={ADMIN_ROUTES.PROFILE} element={<Profile />} />
        <Route path={ADMIN_ROUTES.AGENT} element={<Agent />} />
        <Route path={ADMIN_ROUTES.NEW_AGENT} element={<NewAgent />} />
        <Route path={ADMIN_ROUTES.EDIT_AGENT} element={<NewAgent />} />
        <Route path={ADMIN_ROUTES.VIEW_AGENT} element={<AgentDetail />} />

        <Route
          path={ADMIN_ROUTES.CATEGORY_AMENITIES}
          element={
            <CategoryMenuLayout>
              <AmenitiesPage />
            </CategoryMenuLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CATEGORY_MAIN_CATEGORIES}
          element={
            <CategoryMenuLayout>
              <CategoryPageLayout>
                <CategoryPage />
              </CategoryPageLayout>
            </CategoryMenuLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CATEGORY_MAIN_SUB_CATEGORIES}
          element={
            <CategoryMenuLayout>
              <CategoryPageLayout>
                <SubCategoryPage />
              </CategoryPageLayout>
            </CategoryMenuLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CATEGORY_IMAGE_CATEGORIES}
          element={
            <CategoryMenuLayout>
              <ImageCategoryPage />
            </CategoryMenuLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CATEGORY_FACTS}
          element={
            <CategoryMenuLayout>
              <FactFeaturesPage />
            </CategoryMenuLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CATEGORY_FAQS_CATEGORY_LIST}
          element={
            <CategoryMenuLayout>
              <FaqsCategoryPage />
            </CategoryMenuLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.GROUPS}
          element={
            <CategoryMenuLayout>
              <Groups />
            </CategoryMenuLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.AREA_LIST}
          element={
            <CategoryMenuLayout>
              <AreaListPage />
            </CategoryMenuLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REAL_ESTATE_PROPERTIES}
          element={
            <RealEstateLayout>
              <Properties />
            </RealEstateLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REAL_ESTATE_NEW_PROPERTIES}
          element={
            <RealEstateLayout>
              <NewProperty />
            </RealEstateLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REAL_ESTATE_EDIT_PROPERTIES}
          element={
            <RealEstateLayout>
              <NewProperty />
            </RealEstateLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REAL_ESTATE_VIEW_PROPERTY}
          element={
            <RealEstateLayout>
              <ViewProperty />
            </RealEstateLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REAL_ESTATE_PROJECTS}
          element={
            <RealEstateLayout>
              <Projects />
            </RealEstateLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REAL_ESTATE_NEW_PROJECTS}
          element={
            <RealEstateLayout>
              <NewProject />
            </RealEstateLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REAL_ESTATE_EDIT_PROJECTS}
          element={
            <RealEstateLayout>
              <NewProject />
            </RealEstateLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REAL_ESTATE_VIEW_PROJECT}
          element={
            <RealEstateLayout>
              <ViewProject />
            </RealEstateLayout>
          }
        />
        <Route path={ADMIN_ROUTES.BUILDERS} element={<BuilderListPage />} />
        <Route path={ADMIN_ROUTES.NEW_BUILDERS} element={<BuilderFormPage />} />
        <Route
          path={ADMIN_ROUTES.EDIT_BUILDERS}
          element={<BuilderFormPage />}
        />
        <Route path={ADMIN_ROUTES.VIEW_BUILDER} element={<BuilderDetail />} />

        <Route path={ADMIN_ROUTES.SALES_TEAM} element={<SalesTeam />} />
        <Route
          path={ADMIN_ROUTES.LOCATION_HISTORY_SALES_TEAM_ID}
          element={<SalesLocationHistoryPage />}
        />
        <Route
          path={ADMIN_ROUTES.NEW_SALES_TEAM}
          element={<NewSalesMember />}
        />
        <Route path={ADMIN_ROUTES.LEADS} element={<Leads />} />
        <Route
          path={ADMIN_ROUTES.LEADS_EDIT_LEAD_ID}
          element={<EditLeadPage isEdit={true} />}
        />
        <Route
          path={ADMIN_ROUTES.LEADS_VIEW_LEAD_ID}
          element={<EditLeadPage isEdit={false} />}
        />
        <Route
          path={ADMIN_ROUTES.EDIT_SALES_TEAM}
          element={<NewSalesMember />}
        />
        <Route path={ADMIN_ROUTES.CUSTOMER} element={<CustomerListPage />} />

        <Route
          path={ADMIN_ROUTES.MANAGE_STAFF_ROLES}
          element={
            <ManageStaffLayout>
              <Roles />
            </ManageStaffLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.MANAGE_STAFF_NEW_ROLES}
          element={
            <ManageStaffLayout>
              <NewRoles />
            </ManageStaffLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.MANAGE_STAFF_EDIT_ROLES}
          element={
            <ManageStaffLayout>
              <NewRoles />
            </ManageStaffLayout>
          }
        />

        <Route
          path={ADMIN_ROUTES.MANAGE_STAFF}
          element={
            <ManageStaffLayout>
              <AllStaffPage />
            </ManageStaffLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.MANAGE_STAFF_NEW}
          element={
            <ManageStaffLayout>
              <AllStaffFormActionPage />
            </ManageStaffLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.MANAGE_STAFF_EDIT}
          element={
            <ManageStaffLayout>
              <AllStaffFormActionPage />
            </ManageStaffLayout>
          }
        />

        <Route
          path={ADMIN_ROUTES.CONTENT_MANAGEMENT_FAQS}
          element={
            <CmsPageLayout>
              <FaqsPage />
            </CmsPageLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CONTENT_MANAGEMENT_FAQS_NEW}
          element={
            <CmsPageLayout>
              <FaqsFormPage />
            </CmsPageLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CONTENT_MANAGEMENT_FAQS_EDIT}
          element={
            <CmsPageLayout>
              <FaqsFormPage />
            </CmsPageLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CONTENT_MANAGEMENT_TERMS_SERVICE}
          element={
            <CmsPageLayout>
              <TermAndService />
            </CmsPageLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CONTENT_MANAGEMENT_SLIDER_IMAGE}
          element={
            <CmsPageLayout>
              <SliderImageList />
            </CmsPageLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CONTENT_MANAGEMENT_ABOUT_US}
          element={
            <CmsPageLayout>
              <CmsAboutPage />
            </CmsPageLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CONTENT_MANAGEMENT_ADD_SLIDER_IMAGE}
          element={
            <CmsPageLayout>
              <SliderFormAction />
            </CmsPageLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.CONTENT_MANAGEMENT_EDIT_SLIDER_IMAGE}
          element={
            <CmsPageLayout>
              <SliderFormAction />
            </CmsPageLayout>
          }
        />
        <Route path={ADMIN_ROUTES.SEO} element={<SEO />} />
        <Route path={ADMIN_ROUTES.BLOG_POST} element={<BlogPost />} />

        <Route path={ADMIN_ROUTES.NEW_BLOG} element={<NewBlog />} />
        <Route path={ADMIN_ROUTES.EDIT_BLOG} element={<NewBlog />} />
        <Route path={ADMIN_ROUTES.ENQUIRY} element={<EnquiryListPage />} />
        <Route path={ADMIN_ROUTES.VIEW_ENQUIRY} element={<ViewEnquiryForm />} />
        <Route
          path={ADMIN_ROUTES.NOTIFICATION}
          element={<NotificationList />}
        />
        <Route path={ADMIN_ROUTES.FEEDBACK} element={<FeedbackListPage />} />
        <Route path={ADMIN_ROUTES.CONTACT} element={<Contact />} />
        <Route path={ADMIN_ROUTES.REELS} element={<ReelsList />} />
        <Route
          path={ADMIN_ROUTES.REPORTS_PROPERTY_LIST}
          element={
            <ReportLayout>
              <ReportsList />
            </ReportLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REPORTS_PROPERTY_ID}
          element={
            <ReportLayout>
              <SingleReport />
            </ReportLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REPORTS_PROJECT_LIST}
          element={
            <ReportLayout>
              <ReportsList />
            </ReportLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REPORTS_PROJECT_ID}
          element={
            <ReportLayout>
              <SingleReport />
            </ReportLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REPORTS_REELS_LIST}
          element={
            <ReportLayout>
              <ReportsList />
            </ReportLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REPORTS_REEL_ID}
          element={
            <ReportLayout>
              <SingleReport />
            </ReportLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REPORTS_USERS_LIST}
          element={
            <ReportLayout>
              <ReportsList />
            </ReportLayout>
          }
        />
        <Route
          path={ADMIN_ROUTES.REPORTS_USER_ID}
          element={
            <ReportLayout>
              <SingleReport />
            </ReportLayout>
          }
        />
        <Route path={ADMIN_ROUTES.ADVERTISE} element={<AdvertisePage />} />
        <Route
          path={ADMIN_ROUTES.SALES_RECORDS}
          element={<SalesRecordsPage />}
        />
        <Route
          path={ADMIN_ROUTES.SALES_RECORDS_VIEW}
          element={<ViewSalesDataPage />}
        />
        <Route
          path={ADMIN_ROUTES.WHATS_APP_ANALYTICS}
          element={<WhatsAppList />}
        />
        <Route
          path={ADMIN_ROUTES.WHATS_APP_SEND_MESSAGE}
          element={<WhatsAppSendMessage />}
        />
        <Route
          path={ADMIN_ROUTES.BOOK_CALL_LIST}
          element={<BookCallListPage />}
        />
        <Route
          path={USER_ROUTES.NOT_FOUND}
          element={<Navigate to={ADMIN_ROUTES.ROOT} />}
        />
      </Routes>
    </Suspense>
  );
};

export default AdminRoutes;
